import { render, staticRenderFns } from "./card-cmp.vue?vue&type=template&id=6566267d&scoped=true"
import script from "./card-cmp.vue?vue&type=script&lang=js"
export * from "./card-cmp.vue?vue&type=script&lang=js"
import style0 from "./card-cmp.vue?vue&type=style&index=0&id=6566267d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566267d",
  null
  
)

export default component.exports